export default __webpack_public_path__ + "static/media/dark_bill_icon.440969c6.svg";